import { RootState } from "store";

export const getIsUnderwritingReinstatementAvailable = (state: RootState) =>
  state.account.underwritingAvailability.reinstatementAvailable;
